import axios from 'axios';

export const setPortfolioList = (payload) => ({
    type: "SET_PORTFOLIO_LIST",
    payload: payload
})

export const setPorfolioPrices = (payload) => ({
    type: "SET_PORTFOLIO_PRICES",
    payload: payload
})

export const setPorfolioReturns = (payload) => ({
    type: "SET_PORTFOLIO_RETURNS",
    payload: payload
})

export const setPortfolioChanged = (payload) => ({
    type: "SET_PORTFOLIO_CHANGED",
    payload: payload
})

export const setPortfolioRisks = (payload) => ({
    type: "SET_PORTFOLIO_RISKS",
    payload: payload
})

export const setPortfolioVariance = (payload) => ({
    type: "SET_PORTFOLIO_VARIANCE",
    payload: payload
})

export const setPortfolioReturn = (payload) => ({
    type: "SET_PORTFOLIO_RETURN",
    payload: payload
})

export const fetchPortfolio = data => async dispatch => {
    try {
        const response = await axios.post("/api/stock/fetch-user-portfolio", data);
        dispatch(setPortfolioList(response.data.portfolio));
        return response;
    } catch (error) {
        console.log(error);
        return error;
    }
}

export const fetchPortfolioDetails = data => async dispatch => {
    try {
        if(data.portfolio_changed){
            const response = await axios.post("/api/stock/fetch-portfolio-details", data);
            dispatch(setPorfolioPrices(response?.data?.portfolioData?.prices));
            dispatch(setPorfolioReturns(response?.data?.portfolioData?.returns));
            dispatch(setPortfolioRisks(response?.data?.portfolioData?.risks));
            dispatch(setPortfolioVariance(response?.data?.portfolioData?.portfolio_variance));
            dispatch(setPortfolioReturn(response?.data?.portfolioData?.portfolio_return));
            dispatch(setPortfolioChanged(false));

        }
    } catch (error) {
        console.log(error);
        return error;
    }
}

// Action for adding the stock to the user portfolio
export const addStock = data => async dispatch => {
    try {
        const response = await axios.post("/api/stock/add-to-portfolio", data);
        dispatch(addToPortfolio(response?.data?.addedStock));
        dispatch(setPortfolioChanged(true));
        return response;   
    } catch (error) {
        console.log(error);
        return error.response;
    }
}

// Action for removing the stock from the user portfolio
export const deleteStock = data => async dispatch => {
    try {
        const response = await axios.post("/api/stock/delete-from-portfolio", data);
        dispatch(removeFromPortfolio(response.data.removedStockID));
        dispatch(setPortfolioChanged(true));
        return response;
    } catch (error) {
        console.log(error);
        return error.response;        
    }
}


export const addToPortfolio = (payload) => ({
    type: "ADD_TO_PORTFOLIO",
    payload: payload
})

export const removeFromPortfolio = (payload) => ({
    type: "REMOVE_FROM_PORTFOLIO",
    payload: payload
})
